import Link from 'next/link'

import classNames from 'classnames'

import { ButtonVariants } from '~/components/atoms/Button/Button'
import type { CtaProps } from '~/components/atoms/Ctas/Ctas'
import Ctas from '~/components/atoms/Ctas/Ctas'
import { Icon } from '~/components/atoms/Icon/Icon'
import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { resolveLink } from '~/components/serializers'

import styles from './ReportDownload.module.css'

export interface ReportDownloadItemProps {
  title: string
  summary?: string
  image: ImageProps
  ctas: CtaProps[]
  testID?: string
  moduleId?: string
}

export default function ReportDownloadItem({
  title,
  summary,
  image,
  ctas,
  testID,
  moduleId,
}: ReportDownloadItemProps) {
  const mainCta = ctas?.[0] as any

  let mainLink = '#'
  if (mainCta.link?.internalLink?.url?.slug) {
    mainLink = resolveLink(mainCta.link)
  }
  if (mainCta.link?.externalLink?.url) {
    mainLink = mainCta.link.externalLink?.url?.slug
  }

  return (
    <Link href={mainLink || '#'} className={styles.itemBase}>
      <div data-testid={testID} id={moduleId}>
        <div className={classNames(styles.inner)}>
          <div className={styles.media}>
            {image && image.asset && (
              <Image
                asset={image.asset}
                objectFit="cover"
                sizes="(max-width: 799px) 80vw, 50vw"
                alt={image.alt}
              />
            )}
          </div>
          <div className={styles.content}>
            <div className={styles.contentInner}>
              {title && (
                <Text
                  size={TextSizes.primaryTitleMed}
                  className={styles.title}
                  Tag="p"
                >
                  {title}
                </Text>
              )}
              {summary && (
                <Text
                  size={TextSizes.bodyMed}
                  className={styles.body}
                  dataNoSnippet={true}
                >
                  {summary}
                </Text>
              )}

              {ctas && (
                <div className={styles.ctas}>
                  <Ctas
                    ctas={ctas}
                    iconLeft={<Icon type="Download" />}
                    overrideStyle={
                      ButtonVariants.textLinkMedium as ButtonVariants
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
